import { BkRoutes } from 'bkng';

import { id } from './id/id';

export const configs: BkRoutes = [
    {
        path: "id",
        label: "Organization Configs by ID",
        children: id,
    },
];
